import { ErrorScreen } from "@/components/ErrorScreen";
import { captureException } from "@sentry/react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/(auth)/waitinglist")({
  component: Layout,

  errorComponent: ({ error }) => {
    useEffect(() => {
      captureException(error);
    }, [error]);

    return (
      <ErrorScreen
        error={error as Error}
        title="Error loading auth"
        message="An unknown error occurred while loading the authentication page."
      />
    );
  },
});

function Layout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
